import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Box, Typography, Button } from "@mui/material";
import { Logout } from "@mui/icons-material";
import { setCompany, clearCompany } from "../redux/actions";
import { apiUrl } from "../apiConfig";
import logo from "../logo.JPG";

function Layout({ children }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const company = useSelector((state) => state.company);

  useEffect(() => {
    const fetchCompany = async () => {
      const token = sessionStorage.getItem("token");
      if (!token) return;

      try {
        const res = await fetch(apiUrl("api/v1/auth/me"), {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          dispatch(setCompany(data.company || ""));
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      }
    };

    if (!company) {
      fetchCompany();
    }
  }, [company, dispatch]);

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    dispatch(clearCompany());
    navigate("/login");
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Header */}
      <Box
        component="header"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 3,
          py: 1.5,
          borderBottom: "1px solid",
          borderColor: "grey.200",
          backgroundColor: "#fff",
          position: "sticky",
          top: 0,
          zIndex: 1100,
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1.5, cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <img
            src={logo}
            alt="FinSmart"
            style={{ height: 32, width: 32, objectFit: "contain", borderRadius: 4 }}
          />
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, color: "grey.800", letterSpacing: "-0.01em" }}
          >
            FinSmart
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {company && (
            <Typography
              variant="body2"
              sx={{ color: "grey.600", fontWeight: 500 }}
            >
              {company}
            </Typography>
          )}
          <Button
            size="small"
            onClick={handleLogout}
            startIcon={<Logout fontSize="small" />}
            sx={{
              color: "grey.600",
              textTransform: "none",
              fontWeight: 500,
              "&:hover": { color: "error.main", backgroundColor: "error.50" },
            }}
          >
            Salir
          </Button>
        </Box>
      </Box>

      {/* Main Content */}
      <Box component="main" sx={{ flex: 1 }}>
        {children}
      </Box>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          py: 2,
          textAlign: "center",
          borderTop: "1px solid",
          borderColor: "grey.200",
          backgroundColor: "#fff",
        }}
      >
        <Typography variant="caption" sx={{ color: "grey.500" }}>
          &copy; FinSmart
        </Typography>
      </Box>
    </Box>
  );
}

export default Layout;
